<template>
    <div>
        <v-layout row wrap>
            <v-text-field v-if="select && select.id==4"
                          v-model="numberTimesLoadModel"
                          label="Number of Times"
                          type="number"
                          name="numberTimesLoadModel"
                          :rules="[v => (v>0) || $t('Value must be greater than zero')]"
                          style="width: 50%; padding-right:20px"
            ></v-text-field>
            <v-text-field  v-if="select && select.id==3"
                           v-model="numberDaysSinceFirstAccess"
                           name="numberDaysSinceFirstAccess"
                           label="Number of Days"
                           type="number"
                           :rules="[v => (v>0) || $t('Value must be greater than zero')]"
                           style="width: 50%; padding-right:20px"
            ></v-text-field>
            <v-dialog v-if="select && select.id==2"
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="accessUntilDate"
                      persistent
                      lazy
                      width="290px"
            >
                <template v-slot:activator="{on}">
                    <v-text-field
                            v-model="accessUntilDateFormatedDate"
                            label="Access Until Day"
                            v-on="on"
                            @blur="accessUntilDate = parseDate(accessUntilDateFormatedDate)"
                            style="width: 50%; padding-right:20px"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="accessUntilDate"
                               scrollable
                               :min="new Date().toISOString().substr(0, 10)"
                >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false">{{$t('Cancel')}}</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(accessUntilDate)">{{$t('OK')}}</v-btn>
                </v-date-picker>
            </v-dialog>
            <v-select
                    v-model="select"
                    :items="items"
                    @change="change"
                    item-text="state"
                    item-value="id"
                    :label="$t('Temporary Access Type')"
                    return-object
                    persistent-hint
                    style="width: 50%;"
            >
            </v-select>
        </v-layout>
    </div>
</template>

<script>
    import {VSelect,VTextField,VCheckbox,VForm,VContainer,VLayout,VDatePicker,VBtn,VSpacer,VDialog,VImg,VFlex,VCard} from 'vuetify/lib'


    export default {
        name: "TemporalPermissions",
        components:{VSelect,VTextField,VCheckbox,VForm,VContainer,VLayout,VBtn,VSpacer,VDatePicker,VDialog,VImg,VFlex,VCard},
        data () {
            return {
                temporalPermission:4,
                numberTimesLoadModel:1,
                numberDaysSinceFirstAccess:'',
                accessUntilDate:'',
                accessUntilDateFormatedDate:'',
                modal:false,
                select:{id:4,state: this.$t("Number of Accesses"), desc: this.$t('Set a limit on the number of views')},
                items: [
                    {  id:4,state: this.$t("Number of Accesses"), desc: this.$t('Set a limit on the number of views') },
                    {  id:2,state: this.$t("Access Until"), desc: this.$t('Set a date limit') },
                    {  id:3,state: this.$t("Days Since First Access"), desc: this.$t('Limit the number of days since first access') },
                ]
            }
        },
        props:['temporalPermissions'],
        computed: {
            computedDateFormatted () {
                return this.formatDate(this.accessUntilDate)
            }
        },
        created() {
            this.update();
        },
        watch: {
            accessUntilDate(val) {
                this.accessUntilDateFormatedDate = this.formatDate(this.accessUntilDate);
                this.update();
            },
            numberTimesLoadModel(val){
                this.update();
            },
            numberDaysSinceFirstAccess(val){
                this.update();
            },
        },
        methods:{
            loadValues:function(permission, value) {
                this.temporalPermission = permission;
                this.temporalValue = value;
                //console.log("Updating");
                //console.log(this.temporalPermission);
                //console.log(this.temporalValue);
                if (this.temporalPermission == 4)
                    this.numberTimesLoadModel = this.temporalValue;
                else if (this.temporalPermissions.temporalPermission == 2)
                    this.accessUntilDate = this.temporalValue;
                else if (this.temporalPermissions.temporalPermission == 3)
                    this.numberDaysSinceFirstAccess = this.temporalValue;
            },
            update:function(){
                var temporalPermission=(this.select)?this.select.id :null;
                var temporalValue=null;
                if(temporalPermission==4){
                    temporalValue= this.numberTimesLoadModel;
                }else if(temporalPermission==2){
                    temporalValue=this.accessUntilDate;
                }else if(temporalPermission==3){
                    temporalValue=this.numberDaysSinceFirstAccess;
                }
                this.$emit('input',{temporalPermission:temporalPermission,temporalValue:temporalValue});
            },
            formatDate (date) {
                if (!date) return null
                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },
            parseDate (date) {
                if (!date) return null;
                const [month, day, year] = date.split('/');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            },
            change:function(){
                this.numberTimesLoadModel='';
                this.numberDaysSinceFirstAccess='';
                this.accessUntilDate='';
            },
            clear:function(){
                this.select={id:4,state: this.$t("Number of Accesses"), desc: this.$t('Set a limit on the number of views')};
                this.change();
            }
        }
    }


</script>

<style scoped>
    .v-text-field { padding:0; }
    .v-dialog {
        box-shadow: none !important;
    }
</style>